import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { ChangeLogKeyType } from '@/components/ChangeLog/constant';

import BannerCard from './BannerCard';
import {
  CHANGE_LOG_PATH,
  UPDATE_BANNERS,
  getStorageKey,
} from './index.constants';
import * as Styled from './index.styles';

// 페이지 이동마다 배너가 다시 마운트되므로 노출 여부를 모듈 단위로 기억한다.
// 첫 판단 이후에는 초기 렌더부터 바로 노출되어 깜빡임과 등장 애니메이션 재생이 없다.
let cachedVisibleTabs: ChangeLogKeyType[] | null = null;

const UpdateBanner = () => {
  const router = useRouter();
  const [visibleTabs, setVisibleTabs] = useState<ChangeLogKeyType[]>(
    cachedVisibleTabs ?? [],
  );
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    if (cachedVisibleTabs !== null) {
      return;
    }

    // '1'이면 숨김
    cachedVisibleTabs = UPDATE_BANNERS.filter(
      ({ tab }) => localStorage.getItem(getStorageKey(tab)) !== '1',
    ).map(({ tab }) => tab);

    setVisibleTabs(cachedVisibleTabs);
    setIsAnimated(cachedVisibleTabs.length > 0); // 등장 애니메이션은 최초 노출에서만 재생한다.
  }, []);

  const banners = UPDATE_BANNERS.filter(({ tab }) => visibleTabs.includes(tab));

  // 업데이트 내용을 보고 있는 변경사항 페이지에서는 노출하지 않는다.
  if (banners.length === 0 || router.pathname === CHANGE_LOG_PATH) {
    return null;
  }

  const hideForever = (tab: ChangeLogKeyType) => {
    localStorage.setItem(getStorageKey(tab), '1');
    cachedVisibleTabs = (cachedVisibleTabs ?? []).filter((key) => key !== tab);
    setVisibleTabs(cachedVisibleTabs);
  };

  return (
    <Styled.BannerStack>
      {banners.map(({ tab, description }, index) => (
        <Styled.CardSlot key={tab} depth={index}>
          <BannerCard
            tab={tab}
            description={description}
            isAnimated={isAnimated}
            onClose={() => hideForever(tab)}
          />
        </Styled.CardSlot>
      ))}
    </Styled.BannerStack>
  );
};

export default UpdateBanner;
